import _useCarousel from './Carousel1/useCarousel.jsx'
import Carousel1 from './Carousel1/Carousel1.jsx'

export default Carousel1
export const useCarousel = _useCarousel
